<email-layout [showLogo]="false">
  <ng-container header>
    <email-message-header [header]="data.p1" [separator]="false" />
    <email-margin [height]="18" />
  </ng-container>

  <ng-container body>
    <div class="event-reminder-box">
      <div class="header-section">
        <email-text
          [contents]="data.event_kind"
          [bold]="true"
          presetName="paragraph"
          size="large"
        />
      </div>
      <div class="details-section">
        <email-text
          [contents]="data.when_label"
          presetName="paragraph"
          size="small"
          color="light"
        />
        <email-text [contents]="data.date" presetName="paragraph" size="small" />
        <email-text [contents]="data.timezone" presetName="paragraph" size="small" />
        <ng-container *mailgunIf="data.reschedule_link_url">
          <email-text [contents]="data.reschedule_label" [size]="'small'" />&nbsp;&nbsp;<email-link
            [href]="data.reschedule_link_url"
            [label]="data.reschedule_link"
            [textOpts]="{ bold: true, size: 'small' }"
          />
        </ng-container>

        <email-margin [height]="16" />

        <email-text
          [contents]="data.interviewers_label"
          presetName="paragraph"
          size="small"
          color="light"
        />
        <email-text [contents]="data.interviewers_html" presetName="paragraph" size="small" />

        <email-margin [height]="16" />

        <email-text
          [contents]="data.event_link_label"
          presetName="paragraph"
          size="small"
          color="light"
        />
        <email-link
          [label]="data.event_link"
          [href]="data.event_link"
          [textOpts]="{ size: 'small', bold: true }"
        />

        <email-margin [height]="8" />
      </div>
    </div>
  </ng-container>
</email-layout>
